import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { TrinoCopySource } from 'app/model/pipeline/copysource/trino.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TrinoCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class TrinoCopySourceAdapter extends CopySourceAdapter<TrinoCopySource, Model.TrinoSource> {

    protected override async _toResource(copySource: TrinoCopySource): Promise<Model.TrinoSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(TrinoCopySource).name);
    }

    protected override async _toModel(resource: Model.TrinoSource, copyActivity: CopyActivity): Promise<TrinoCopySource> {
        return this._toTabularModel(resource, copyActivity, TrinoCopySource.MODEL);
    }
}
